import {noop} from "lodash";
import {
    Aging_Search,
    ASN_Search,
    Batch_Inv_Search, Batch_Send_Email, Collect_Payment,
    Commodity_Info,
    Commodity_Save,
    Commodity_Update,
    Cost_Details, Cost_Details_Info,
    Cost_Info, Date_Search,
    Dict_Type,
    Expire_Inv_Search,
    Export_Aging,
    Export_ASN,
    Export_Batch,
    Export_Cost_Details,
    Export_Cost_Info, Export_Date,
    Export_Expire,
    Export_Individual,
    Export_Location,
    Export_Sale_Batch,
    Export_Sale_Customer,
    Export_Sale_SKU,
    Export_Sku,
    Export_Summary,
    Export_Warehouse, Generate_Invoice_Pdf,
    Individual_Search,
    Invoice_Download_Info, Invoice_Download_Pdf_File, Invoice_Export_Item_list,
    Invoice_Info,
    Invoice_Item_Detail,
    Invoice_Search,
    Location_Search,
    Non_Canadian_Shipping_Download,
    Non_Canadian_Shipping_Owner_List,
    Non_Canadian_Shipping_Search, Other_Fee_Cancel,
    Other_Fee_Download,
    Other_Fee_Info, Other_Fee_List,
    Other_Fee_Search,
    Owner_Cash, Owner_Cash_Audit,
    Owner_Cash_Edit,
    Owner_Cash_Info,
    Owner_Cash_List,
    Owner_Cash_Save, Owner_Cash_Submit,
    Requisition_Download,
    Requisition_Information, Requisition_OCP_Generate,
    Requisition_Search,
    Sales_Batch_Search,
    Sales_Customer_Search,
    Sales_SKU_Search, Send_To_Quickbooks,
    Sku_Search,
    Storage_Fee_Download,
    Storage_Fee_Search,
    Storage_Fee_Update,
    Summary_Search, Transaction_Report_Export, Transaction_Report_Filter,
    Warehouse_Search
} from "../../config";
import api from "../../api/api";
import moment from "moment";
import {DashboardActionType} from "../dashboard/dashboardAction";
import progressApi from "../../api/progressApi";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {SystemActionType} from "../system/systemAction";

export const ReportsActionType = {
    Aging_List:"Aging_List",
    SKU_List:'SKU_List',
    Batch_List:'Batch_List',
    Expire_List:'Expire_List',
    Location_List:'Location_List',
    ASN_List:'ASN_List',
    Requisition_List:'Requisition_List',
    Invoice_List:'Invoice_List',
    Invoice_Info:'Invoice_Info',
    Invoice_Item_Detail:'Invoice_Item_Detail',
    Invoice_Download_Info:'Invoice_Download_Info',
    Reset_Invoice_Download_Info:'Reset_Invoice_Download_Info',
    Reset_Invoice:'Reset_Invoice',
    Other_Fee_List:'Other_Fee_List',
    Other_Fee_Info:'Other_Fee_Info',
    Reset_Other_Fee:'Reset_Other_Fee',
    Storage_Fee_List:'Storage_Fee_List',
    BusinessTypeList:'BusinessTypeList',
    Summary_List:'Summary_List',
    Individual_List:'Individual_List',
    Warehouse_List:'Warehouse_List',
    Sale_SKU_List:'Sale_SKU_List',
    Sale_Customer_List:'Sale_Customer_List',
    Sale_Batch_List:'Sale_Batch_List',
    Cost_Info_List:'Cost_Info_List',
    Cost_Details_List:'Cost_Details_List',
    Cost_Details_List_Info:'Cost_Details_List_Info',
    Non_Canadian_Shipping_List:'Non_Canadian_Shipping_List',
    Non_Canadian_Shipping_Owner_List:'Non_Canadian_Shipping_Owner_List',
    Owner_Cash_List:'Owner_Cash_List'
}

export const agingFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportInventoryAging)) return null;
        const url = `${Aging_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Aging_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const getReceiveBusinessTypeList = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_receive_business_type_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:ReportsActionType.BusinessTypeList,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const requisitionFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    if (!checkPermission(PERMISSION_DICT.BillingCollectionList)) return null;

    try {
        const url = `${Requisition_Search}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Requisition_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}



export const collectionDownload = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingCollectionExport)) return null;
        const url = `${Requisition_Download}`
        const response = await progressApi.post(url, {...data},{
            responseType: 'blob' // 设置响应类型为 Blob
        })
        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Collection_Requisition_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }

    }
    catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }
}


export const invoiceFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.BillingInvoiceList)) return null;
        const url = `${Invoice_Search}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Invoice_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const sendToQB = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceSendToQB)) return null;
        const url = `${Send_To_Quickbooks}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("Send to Quickbooks Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const collectPayment = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceCollect)) return null;
        const url = `${Collect_Payment}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("Collect Payment Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}

export const generatePDF = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceGeneratePDF)) return null;
        const url = `${Generate_Invoice_Pdf}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("Generate Invoice PDF Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}


export const sendEmail = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceEmailBatchSend)) return null;
        const url = `${Batch_Send_Email}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response?.data?.code === 200){
            onSuccess("Send Email Successfully")
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }
}


export const invoiceInfoDetail = (data,onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.BillingInvoiceDetail)) return null;

        const url = `${Invoice_Item_Detail}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:ReportsActionType.Invoice_Item_Detail,
                payload:response?.data?.data
            })
            onSuccess()
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const invoiceInfo = (data,onSuccess=noop,onError=noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingInvoiceInfo)) return null;
        const url = `${Invoice_Info}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Invoice_Info,
            //     payload:response?.data?.data
            // })
            onSuccess(response?.data?.data)
        } else {
            // console.log(response)
            onError("Error occurred while getting invoice info")
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const resetInvoiceInfo = () => async dispatch =>{
    try {
        dispatch({
            type:ReportsActionType.Reset_Invoice,
            payload: ""})
    } catch (e) {
        console.log(e.message)
    }
}

export const resetInvoiceDownloadInfo = () => async dispatch =>{
    try {
        dispatch({
            type:ReportsActionType.Reset_Invoice_Download_Info,
            payload: ""})
    } catch (e) {
        console.log(e.message)
    }
}
export const invoiceDownloadInfo = (data,onSuccess,onError) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingInvoicePrint)) return null;
        const url = `${Invoice_Download_Info}`
        const response = await progressApi.post(url, {...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:ReportsActionType.Invoice_Download_Info,
                payload:response?.data?.data
            })
            onSuccess()
        } else {
            // console.log(response)
            onError("Error occurred while getting invoice pdf info")
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadInvoiceItemList = (data,onSuccess= noop,onError= noop) => async () =>{
    try{
        if (!checkPermission(PERMISSION_DICT.BillingInvoiceDetailExport)) return null;
        const xurl = `${Invoice_Export_Item_list}`
        const response = await api.post(xurl,{...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        }).then( res=>res)
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }
        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Invoice_Item_list_For_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }
}


export const downloadInvoicePdfFile = (data,onSuccess= noop,onError= noop) => async () =>{
    try{
        // if (!checkPermission(PERMISSION_DICT.BillingInvoiceDetailExport)) return null;
        const xurl = `${Invoice_Download_Pdf_File}`
        const response = await api.post(xurl,{...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        }).then( res=>res)
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }
        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = data?.fileName? data.fileName : `Invoice_${moment().format('YYYYMMDD')}.pdf`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }
}


export const otherFeeFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.BillingOtherList)) return null;
        const url = `${Other_Fee_Search}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Other_Fee_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            // console.log(response)
            // onError(response.data.msg,response?.data.code)
            onError("Error occurred while getting other fee info")
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const otherFeeList = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.BillingOtherList)) return null;
        const url = `${Other_Fee_List}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Other_Fee_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            // console.log(response)
            // onError(response.data.msg,response?.data.code)
            onError("Error occurred while getting other fee info")
        }

    }
    catch (e) {
        onError(e.message)
    }
}



export const otherFeeInfo = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingOtherInfo)) return null;
        const url = `${Other_Fee_Info}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Other_Fee_Info,
            //     payload:response?.data?.data
            // })
            onSuccess(response?.data?.data)
        } else {
            // console.log(response)
            onError("Error occurred while getting other fee info")
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const cancelOtherFee = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingOtherCancel)) return null;
        const url = `${Other_Fee_Cancel}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess('Other fee Successfully cancelled')
        } else {
            // console.log(response)
            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const otherFeeDownload = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingOtherExport)) return null;
        const url = `${Other_Fee_Download}`
        const response = await api.post(url, {...data},{
            responseType: 'blob' // 设置响应类型为 Blob
        })
        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Other_Fee_Receivables_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }

    }
    catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }
}

export const resetOtherFeeInfo = () => async dispatch =>{
    try {
        dispatch({
            type:ReportsActionType.Reset_Other_Fee,
            payload: ""})
    } catch (e) {
        console.log(e.message)
    }
}


export const storageFeeFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.BillingStorageList)) return null;
        const url = `${Storage_Fee_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Storage_Fee_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            // console.log(response)
            // onError(response.data.msg,response?.data.code)
            onError("Error occurred while getting storage fee info")
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeUpdate = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.BillingStorageUpdate)) return null;
        const url = `${Storage_Fee_Update}`
        const response = await progressApi.post(url, {...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
             onSuccess("BillingPage.StorageFeePage.Update filtered storage fee info successfully")
        } else {
            // console.log(response)
            // onError(response.data.msg,response?.data.code)
            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const storageFeeDownload = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingStorageExport)) return null;
        const url = `${Storage_Fee_Download}`
        const response = await progressApi.post(url, {...data},{
            responseType: 'blob' // 设置响应类型为 Blob
        })
        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(jsonResponse.msg)
            // onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Storage_Fee_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }

    }
    catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }
}





export const nonCanadianShippingFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportNonCanadaList)) return null;
        const url = `${Non_Canadian_Shipping_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Non_Canadian_Shipping_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            // console.log(response)
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}



export const nonCanadianShippingOwnerList = (onSuccess = noop,onError = noop) => async dispatch => {
    try {
        const url = `${Non_Canadian_Shipping_Owner_List}`
        const response = await api.get(url, {
            params: {
                username: localStorage.getItem('username')
            }})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:ReportsActionType.Non_Canadian_Shipping_Owner_List,
                payload:response.data
            })
            onSuccess(response.data)
        } else {
            // console.log(response)
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const nonCanadianShippingDownload = (data,onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.ReportNonCanadaExport)) return null;
        const url = `${Non_Canadian_Shipping_Download}`
        const response = await api.post(url, {...data},{
            responseType: 'blob' // 设置响应类型为 Blob
        })
        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Non_Canada_Shipping_Fee_Detail_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }

    }
    catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }
}




export const downloadAgingReport = (data,onSuccess= noop,onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportInventoryAgingExport)) return null;
        const xurl = `${Export_Aging}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Aging_Inventory_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const skuInventoryFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportInventorySku)) return null;
        const url = `${Sku_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.SKU_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadSkuReport = (data,onSuccess= noop, onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportInventorySkuExport)) return null;
        const xurl = `${Export_Sku}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if(response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Sku_Inventory_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const batchInvFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportInventoryBatch)) return null;
        const url = `${Batch_Inv_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadBatchReport = (data,onSuccess= noop , onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportInventoryBatchExport)) return null;
        const xurl = `${Export_Batch}`
        const response = await api.post(xurl, {...data},{
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }


        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Batch_Inventory_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response?.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const dateFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportInventoryDate)) return null;
        const url = `${Date_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Aging_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadDateReport = (data,onSuccess= noop,onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportInventoryDateExport)) return null;
        const xurl = `${Export_Date}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Date_Inventory_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const expireInvFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.ReportInventoryExpire)) return null;
        const url = `${Expire_Inv_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Expire_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadExpireDateReport = (data,onSuccess= noop , onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportInventoryExpireExport)) return null;
        const xurl = `${Export_Expire}`
        const response = await api.post(xurl, {...data},{
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if(response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Expired_Date_Inventory_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response?.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        onError('Error occurred while downloading file:', error.message)
        console.error('Error occurred while downloading file:', error);
    }

}


export const locationInvFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportInventoryLocation)) return null;
        const url = `${Location_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Location_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadLocationReport = (data,onSuccess= noop, onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportInventoryLocationExport)) return null;
        const xurl = `${Export_Location}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Location_Inventory_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response?.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const asnFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportInventoryAsn)) return null;
        const url = `${ASN_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.ASN_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const downloadASNReport = (data,onSuccess= noop, onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportInventoryAsnExport)) return null;
        const xurl = `${Export_ASN}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `ASNs_Inventory_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response?.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadCostInfoReport = (data,onSuccess= noop , onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportFulfillmentCostExport)) return null;
        const xurl = `${Export_Cost_Info}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Fulfillment_Cost_Info_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadCostDetailsReport = (data,onSuccess= noop , onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportFulfillmentCostDetailExport)) return null;
        const xurl = `${Export_Cost_Details}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Fulfillment_Cost_Details_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const requisitionInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.BillingCollectionInfo)) return null;

        const url = `${Requisition_Information}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response.data.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        console.log(e)
        onError(e.message)
    }
}


export const summaryFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportSalesSummery)) return null;
        const url = `${Summary_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Summary_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const fulfillmentCostInfoFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportFulfillmentCost)) return null;
        const url = `${Cost_Info}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        // console.log(response.data.data)
        if(response?.status === 200 && response.data.code === 200){

            // dispatch({
            //     type:ReportsActionType.Cost_Info_List,
            //     payload:response.data.data
            // })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const fulfillmentCostDetailsFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportFulfillmentCostDetail)) return null;
        const url = `${Cost_Details}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            // dispatch({
            //     type:ReportsActionType.Cost_Details_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const fulfillmentCostDetailsInfo = (data,onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportFulfillmentCostDetailInfo)) return null;

        const url = `${Cost_Details_Info}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:ReportsActionType.Cost_Details_List_Info,
                payload:response?.data?.data
            })
            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}


export const salesSkuFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportSalesSku)) return null;
        const url = `${Sales_SKU_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Sale_SKU_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const salesCustomerFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportSalesCustomer)) return null;
        const url = `${Sales_Customer_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Sale_Customer_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const salesBatchFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportSalesBatch)) return null;
        const url = `${Sales_Batch_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Sale_Batch_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadSalesSummaryReport = (data,onSuccess= noop,onError= noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportSalesSummeryExport)) return null;
        const xurl = `${Export_Summary}`
        const response = await api.post(xurl, data, {
            responseType: 'blob' // 设置响应类型为 Blob
        })
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Sales_Summary_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadSalesIndividualReport = (data,onSuccess= noop,onError= noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportSalesIndividualExport)) return null;
        const xurl = `${Export_Individual}`
        const response = await api.post(xurl,{...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if  (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Sales_Individuals_Report_For_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadSalesWarehouseReport = (data,onSuccess= noop,onError= noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportSalesWarehouseExport)) return null;
        const xurl = `${Export_Warehouse}`
        const response = await api.post(xurl,{...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        }).then( res=>res)

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if  (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Sales_Warehouse_Report_For_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const warehouseAreaFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.ReportSalesWarehouse)) return null;
        const url = `${Warehouse_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Warehouse_List,
            //     payload:response.data
            // })

            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const individualFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.ReportSalesIndividual)) return null;
        const url = `${Individual_Search}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:ReportsActionType.Individual_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadSalesSKUReport = (data,onSuccess= noop,onError= noop) => async () =>{
     try{

        if (!checkPermission(PERMISSION_DICT.ReportSalesSkuExport)) return null;
        const xurl = `${Export_Sale_SKU}`
        const response = await api.post(xurl,{...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        }).then( res=>res)

         const text = await response.data.text();
         let jsonResponse;
         try {
             jsonResponse = JSON.parse(text);
         } catch (e) {
             // 解析失败，说明响应是一个有效的 Blob 文件
             jsonResponse = null;
         }

         if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
             // 服务器返回了200但响应体中包含错误码500
             onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
             console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
         } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Sales_SKU_Report_For_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
         if (error.response) {
             // 请求已发出，服务器响应了状态码范围在 2xx 之外
             console.error('Error response status:', error.response.status);
             console.error('Error response data:', error.response.data);
             onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
         } else if (error.request) {
             // 请求已发出但没有收到响应
             console.error('Error request:', error.request);
             onError('Error occurred while downloading file: No response received from server');
         } else {
             // 其他错误
             console.error('Error:', error.message);
             onError(`Error occurred while downloading file: ${error.message}`);
         }
    }

}

export const downloadSalesCustomerReport = (data,onSuccess= noop,onError= noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.ReportSalesCustomerExport)) return null;
        const xurl = `${Export_Sale_Customer}`
        const response = await api.post(xurl,{...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })


        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Sales_Customer_Report_For_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadSalesBatchReport = (data,onSuccess= noop,onError= noop) => async () =>{


    try{

        if (!checkPermission(PERMISSION_DICT.ReportSalesBatchExport)) return null;
        const xurl = `${Export_Sale_Batch}`
        const response = await api.post(xurl,{...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Sales_Batch_Report_For_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.status)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const ownerCashFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.BillingCashList)) return null;
        const url = `${Owner_Cash_List}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response?.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const getOwnerCashInfo = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCashInfo)) return null;
        const url = `${Owner_Cash_Info}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response?.data?.data?.ocpOwnerCashEntity)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const ownerCashSave = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCashAdd)) return null;
        const url = `${Owner_Cash_Save}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("BillingPage.OwnerCashPage.Create owner cash successfully")
        } else {

            onError(response.data.msg||"BillingPage.OwnerCashPage.Failed to create owner cash",response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const ownerCashSubmit = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCashSubmit)) return null;
        const url = `${Owner_Cash_Submit}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("BillingPage.OwnerCashPage.Submit owner cash successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const ownerCashAudit = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.BillingCashAudit)) return null;
        const url = `${Owner_Cash_Audit}`
        const response = await api.post(url,data)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess("BillingPage.OwnerCashPage.Audit owner cash successfully")
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const transactionFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.ReportTransaction)) return null;
        const url = `${Transaction_Report_Filter}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            // dispatch({
            //     type:ReportsActionType.Cost_Details_List,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const downloadTransactionReport = (data,onSuccess= noop , onError = noop) => async () =>{

    try{

        // if (!checkPermission(PERMISSION_DICT.ReportTransactionExport)) return null;
        const xurl = `${Transaction_Report_Export}`
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Transaction_Report_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            onError('Failed to download file. Server responded with status:', response.msg)
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

